import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const MenuIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <svg width="29" height="29" viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.16667 18.75H26.8333C27.6812 18.75 28.375 18.0562 28.375 17.2083C28.375 16.3604 27.6812 15.6667 26.8333 15.6667H2.16667C1.31875 15.6667 0.625 16.3604 0.625 17.2083C0.625 18.0562 1.31875 18.75 2.16667 18.75ZM2.16667 11.0417H26.8333C27.6812 11.0417 28.375 10.3479 28.375 9.5C28.375 8.65208 27.6812 7.95833 26.8333 7.95833H2.16667C1.31875 7.95833 0.625 8.65208 0.625 9.5C0.625 10.3479 1.31875 11.0417 2.16667 11.0417ZM0.625 1.79167C0.625 2.63958 1.31875 3.33333 2.16667 3.33333H26.8333C27.6812 3.33333 28.375 2.63958 28.375 1.79167C28.375 0.94375 27.6812 0.25 26.8333 0.25H2.16667C1.31875 0.25 0.625 0.94375 0.625 1.79167Z" fill="black"/>
    </svg>    
  );
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

MenuIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default MenuIcon;
